import React from 'react';
import { Modal, Space, Typography, List, Button } from 'antd';
import { WarningOutlined, CheckOutlined } from '@ant-design/icons';
import { useTranslation } from '@refinedev/core';
import { ChangeRequest } from '@/api/types/getOneReq';
import { formatAmmanDateTime } from '@/utils/formatAmmanDateTime';

const { Text } = Typography;

interface ChangeRequestModalProps {
  open: boolean;
  onClose: () => void;
  changeRequests: ChangeRequest[];
  title: string;
  onResolve: (change_request_id: number) => void;
  resolveLoading?: boolean;
}

export const ChangeRequestModal: React.FC<ChangeRequestModalProps> = ({
  open,
  onClose,
  changeRequests,
  title,
  onResolve,
  resolveLoading,
}) => {
  const { translate } = useTranslation();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      centered
      title={
        <Space>
          <WarningOutlined className="text-warning" />
          {title}
        </Space>
      }
      footer={null}
    >
      <List
        dataSource={changeRequests}
        locale={{
          emptyText: (
            <div className="py-8 text-center">
              <Text type="secondary">{translate('changeRequests.empty')}</Text>
            </div>
          ),
        }}
        renderItem={(request) => (
          <List.Item>
            <List.Item.Meta
              title={
                <Space>
                  <Text>{request.description}</Text>
                  {request.status === 'PENDING' && (
                    <Button
                      type="primary"
                      size="small"
                      icon={<CheckOutlined />}
                      loading={resolveLoading}
                      onClick={() => onResolve(request.id)}
                    >
                      {translate('buttons.resolveComment')}
                    </Button>
                  )}
                </Space>
              }
              description={
                <Space direction="vertical" size="small">
                  <Text type="secondary">
                    {translate('changeRequests.requestedBy')}:{' '}
                    {request.requested_by_id}
                  </Text>
                  <Text type="secondary">
                    {translate('changeRequests.createdAt')}:{' '}
                    {formatAmmanDateTime(
                      request.created_at,
                      'YYYY-MM-DD HH:mm:ss'
                    )}
                  </Text>
                </Space>
              }
            />
          </List.Item>
        )}
      />
    </Modal>
  );
};
